module.exports = __webpack_public_path__ + "static/img/sy_7.8a321e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_7.png
// module id = 4FnF
// module chunks = 1